import { HoldingClass, Partner } from 'types';

export enum TradingOfferType {
  BUY = 'BUY', // eslint-disable-line no-unused-vars
  SELL = 'SELL', // eslint-disable-line no-unused-vars
}

export enum TradingOfferStatus {
  DRAFT = 'DRAFT', // eslint-disable-line no-unused-vars
  PENDING = 'PENDING', // eslint-disable-line no-unused-vars
  ACTIVE = 'ACTIVE', // eslint-disable-line no-unused-vars
  ACCEPTED = 'ACCEPTED', // eslint-disable-line no-unused-vars
  REJECTED = 'REJECTED', // eslint-disable-line no-unused-vars
  EXPIRED = 'EXPIRED', // eslint-disable-line no-unused-vars
  CANCELED = 'CANCELED', // eslint-disable-line no-unused-vars
}

export type TradingOfferSharesCount = {
  total: number;
  agreed: number;
  approved: number;
};

/** Stored when the partner publishes an offer (server + client audit for contracts). */
export type TradingOfferPublisherAudit = {
  serverCapturedAt?: Date | string;
  clientIp?: string;
  forwardedFor?: string;
  requestUserAgent?: string;
  clientContext?: Record<string, unknown>;
};

export type TradingOffer = {
  _id: string;
  society: string;
  partner: string | Partial<Partner>;
  shareClass: string | Partial<HoldingClass> | null;
  emailSubsidiary?: string;
  documents: Array<
    string | { _id: string; name?: string; description?: string }
  >;
  sharesCount: TradingOfferSharesCount;
  sharePrice: number;
  startDate: Date | string;
  endDate: Date | string;
  type: TradingOfferType;
  isPartialAmountEnabled: boolean;
  minSharesPerAcceptance?: number;
  isSellerNameHidden: boolean;
  createdAt: Date | string;
  updatedAt: Date | string;
  offerPublisherAudit?: TradingOfferPublisherAudit;
};

export type PartnerAgreedTradingOffer = {
  tradingOffer: string | TradingOffer;
  sharesCount: {
    agreed: number;
  };
  date: Date | string;
  isApproved: boolean;
  documents: string[];
};

export type TradingOffersCount = {
  buy: number;
  sell: number;
  total: number;
};

export type TradingOffersSummary = {
  offersCount: number;
  sharesCount: number;
  totalAmount: number;
};

export type TradingOfferPriceContext = {
  currentOfferPrice: number;
  lastTransactionPrice: number;
  avgSellOffersPrice: number;
  officialValuation: number;
  userAvgBuyPrice: number;
};

export type TradingOfferTimelineStep = {
  key: string;
  label: string;
  icon?: string;
  date?: string;
  isCompleted: boolean;
  isCurrent: boolean;
};

export type TradingOfferSellerInfo = {
  partnerId: string;
  name: string;
  image?: string;
  memberSince: string;
  totalShares: number;
  capitalPercentage: number;
  previousOperations: number;
  rating: number;
};
